import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrderApiService} from '../../../../core/services/order.api.service';
import {PaymentStore} from '../../../../core/stores/payment.store';

@Component({
  selector: 'app-ikon-pass',
  templateUrl: './ikon-pass.component.html',
  styleUrls: ['./ikon-pass.component.scss'],
})
export class IkonPassComponent implements OnInit {
  @Input() public invalidIkon: boolean = false;
  @Output() public ikonPassResponse: EventEmitter<string> = new EventEmitter();
  public ikonPassNumber: string;
  public showTooltip = false;
  public inProgress: boolean;
  public inProgressDelete: boolean;

  constructor(
    private orderApiService: OrderApiService,
    private paymentStore: PaymentStore
  ) { }

  ngOnInit() {
    this.getSavedCustomer();
  }

  public saveIkon(): void {
    this.inProgress = true;
    this.invalidIkon = false;
    this.orderApiService.post(
      `customers/${this.paymentStore.customer.orderBotUserId}/ikon-pass`,
      {ikon_pass_id: this.ikonPassNumber}
    ).subscribe(() => {
      this.invalidIkon = false;
      this.inProgress = false;
      this.paymentStore.customer.ikon_pass_id = this.ikonPassNumber;
      this.ikonPassResponse.emit(this.ikonPassNumber);
    }, () => {
      this.inProgress = false;
      this.invalidIkon = true;
    });
  }

  public deleteIkonPass(): void {
    this.inProgressDelete = true;
    this.invalidIkon = false;
    this.ikonPassNumber = null;
    this.orderApiService.delete(
      `customers/${this.paymentStore.customer.orderBotUserId}/ikon-pass`
    ).subscribe(() => {
      this.invalidIkon = false;
      this.inProgressDelete = false;
      this.paymentStore.customer.ikon_pass_id = this.ikonPassNumber;
      this.ikonPassResponse.emit(this.ikonPassNumber);
    }, () => {
      this.inProgressDelete = false;
      this.invalidIkon = true;
    });
  }

  private getSavedCustomer(): void {
    this.paymentStore.customer$.subscribe(customer => {
      if (customer?.ikon_pass_id) {
        this.ikonPassNumber = customer.ikon_pass_id;
        this.ikonPassResponse.emit(this.ikonPassNumber);
      }
    });
  }

}
